import { DragDirections } from "./resizers"

export const enforce = (
  proposedPosition: {
    x: number
    width: number
    y: number
    height: number
  },
  dragDirections: DragDirections,
  dimensions?: { width: number; height: number },
) => {
  if (dimensions && dimensions.width && dimensions.height) {
    const aspectRatio = dimensions.width / dimensions.height
    if (dragDirections.bottom || dragDirections.top) {
      const desiredWidth = proposedPosition.height * aspectRatio
      const widthAdjustment = desiredWidth - proposedPosition.width
      if (dragDirections.left) {
        return {
          x: proposedPosition.x - widthAdjustment,
          width: proposedPosition.width + widthAdjustment,
        }
      }
      if (dragDirections.right) {
        return {
          width: proposedPosition.width + widthAdjustment,
        }
      }
      return {
        x: proposedPosition.x - widthAdjustment / 2,
        width: proposedPosition.width + widthAdjustment,
      }
    }
    if (dragDirections.left || dragDirections.right) {
      const desiredHeight = proposedPosition.width / aspectRatio
      const heightAdjustment = desiredHeight - proposedPosition.height
      return {
        y: proposedPosition.y - heightAdjustment / 2,
        height: proposedPosition.height + heightAdjustment,
      }
    }
    // const widthProjectionPoint = proposedPosition.width / aspectRatio
    // const horizontalScaleFactor = dimensions.width ** 2 / (dimensions.width ** 2 + dimensions.height ** 2)
    // const horizontalAdjustment = (widthProjectionPoint - dimensions.width) * (horizontalScaleFactor)
    // const heightProjectionPoint = proposedPosition.height * aspectRatio
    // const verticalScaleFactor = dimensions.height ** 2 / (dimensions.width ** 2 + dimensions.height ** 2)
    // const verticalAdjustment = (heightProjectionPoint - dimensions.height) * (verticalScaleFactor)
    // return {
    //   width: dimensions.width + horizontalAdjustment,
    //   height: dimensions.height + verticalAdjustment
    // }
  }
  return undefined
}
